import Model from "../Model";

export interface TReportingPeriodFormType {
  id: number;
  formName: string;
  formReportingPeriodId: number;
  currentVersion: number;
  status: string;
  dateOfLastChange?: Date;
  sendDate?: Date;
  formTypeCode: string;
  formTypeStatus: string;
}

export interface IReportingPeriodFormType extends TReportingPeriodFormType {}

const ReportingPeriodFormType = Model(
  (model: TReportingPeriodFormType): IReportingPeriodFormType => {
    const _reportingPeriodFormType: TReportingPeriodFormType = Object.assign(
      {},
      model
    );

    return {
      get id() {
        return _reportingPeriodFormType.id;
      },

      set id(value) {
        _reportingPeriodFormType.id = value;
      },

      get formName() {
        return _reportingPeriodFormType.formName;
      },

      set formName(value) {
        _reportingPeriodFormType.formName = value;
      },

      get formReportingPeriodId() {
        return _reportingPeriodFormType.formReportingPeriodId;
      },

      set formReportingPeriodId(value) {
        _reportingPeriodFormType.formReportingPeriodId = value;
      },

      get currentVersion() {
        return _reportingPeriodFormType.currentVersion;
      },

      set currentVersion(value) {
        _reportingPeriodFormType.currentVersion = value;
      },

      get status() {
        return _reportingPeriodFormType.status;
      },

      set status(value) {
        _reportingPeriodFormType.status = value;
      },

      get dateOfLastChange() {
        return _reportingPeriodFormType.dateOfLastChange;
      },

      set dateOfLastChange(value) {
        _reportingPeriodFormType.dateOfLastChange = value;
      },

      get sendDate() {
        return _reportingPeriodFormType.sendDate;
      },

      set sendDate(value) {
        _reportingPeriodFormType.sendDate = value;
      },

      get formTypeCode() {
        return _reportingPeriodFormType.formTypeCode;
      },

      set formTypeCode(value) {
        _reportingPeriodFormType.formTypeCode = value;
      },

      get formTypeStatus() {
        return _reportingPeriodFormType.formTypeStatus;
      },

      set formTypeStatus(value) {
        _reportingPeriodFormType.formTypeStatus = value;
      }
    };
  }
);

export default ReportingPeriodFormType;
